import DashboardAnalyticsService from '../../services/DashboardAnalyticsService';
import dashboardAnalyticsUseCase from './dashboardAnalyticsUseCase';

const dashboardAnalyticsFactory = dashboardAnalyticsUseCase({
  DashboardAnalyticsService: DashboardAnalyticsService(),
});

export default dashboardAnalyticsFactory;
